<template>
  <div class="search">
    <div class="myRow">
      <el-form @submit.native.prevent ref='search-filter-form' :model="form" label-width='100px'>
        <el-row :gutter='30'>

          <el-col :span='8' :offset='8'>
            <el-form-item label='厂商'>
              <el-select v-model="form.unit_id" placeholder='选择厂商' size='mini' filterable @change="currentPage = 1; doSearch()">
                <el-option label='全部厂商' :value="''"></el-option>
                <el-option v-for="(value, key) in unitlist" :key="key" :label='value' :value='Number(key)'></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label='关键字检索:'>
              <el-input v-model="form.cdit" type="text" size='mini' placeholder="课程ID或saas课程uuid" @keyup.enter.native='currentPage = 1; doSearch()' clearable @clear='currentPage = 1; doSearch()'>
                <el-button slot="append" icon="el-icon-search" @click="currentPage = 1; doSearch()"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
   
    <div class="flex-row-between">
      <h3 width='100px'>课程列表</h3>
      <div>当前 {{total > 0 ? (pageStart + 1) : 0}} - {{pageEnd > total ? total : pageEnd}} 项, 共 {{total}} 项</div>
    </div>
    <el-table
      :data='lessonlist'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
    >
      <el-table-column
        type="index"
        width="100"
        :index='indexMethod'
      />
      <el-table-column
        prop='id'
        label='课程id'
      />
      <el-table-column
        prop='uuid'
        label='saas课程uuid'
      />
      <el-table-column label='上课厂商'>
        <template slot-scope='scope'>
          {{unitlist[scope.row.unit_id] || '未知'}}
        </template>
      </el-table-column>
      <el-table-column
        prop='name'
        label='课程名称'
      />
      <el-table-column label='课程状态'>
        <template slot-scope='scope'>
          {{session_status ? (session_status.find(s => s.no == scope.row.status_no).name || '未知') : '未知'}}
        </template>
      </el-table-column>
      <el-table-column label='开始时间' width='180'>
        <template slot-scope='scope'>
          {{scope.row.create_dt}}
        </template>
      </el-table-column>
      <el-table-column label='结束时间' width='180'>
        <template slot-scope='scope'>
          {{scope.row.end_dt}}
        </template>
      </el-table-column>
      <el-table-column label='操作'>
        <template slot-scope='scope'>
          <el-button type='primary' size='mini' @click="getDetail(scope.row.id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="flex-row-end" style="margin-top: 16px;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        v-if="total > pageSize"
        @current-change="onPageChange"
        :current-page.sync='currentPage'
      >
      </el-pagination>
    </div>


    <h3 width='100px'>课程详情</h3>
    <el-table
      :data='detail'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
    >
      <el-table-column
        type="index"
        width="70"
      />
      <el-table-column
        prop='customer_name'
        label='用户名'
      />
      <el-table-column
        prop='cle'
        label='卡路里'
      />
      <el-table-column
        prop='ck'
        label='CK值'
      />
      <el-table-column
        prop='max_hr'
        label='最大心率'
      />
      <el-table-column label='心率数据数量'>
        <template slot-scope='scope'>
          {{scope.row.hr_values ? (!!scope.row.hr_values ? Object.keys(JSON.parse(scope.row.hr_values)).length : 0) : 0}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import { get, post } from '@/utils/http'
  import { mapState } from 'vuex'
  export default {
    data() {
      return {
        lessonlist: [],
        detail: [],
        unitlist: {},
        form: {
          unit_id: '',
          cdit: ''
        },
        total: 0,
        pageStart: 0,
        pageEnd: 0,
        currentPage: 1,
        pageSize: 10,
        loading: false,
        detailId: ''
      }
    },
    computed: {
      ...mapState(['session_status'])
    },
    mounted() {
      this.getUnitlist()
      this.doSearch()
    },
    methods: {
      // 获取厂商列表
      async getUnitlist() {
        try {
          const res = await get('/index/Unit/getUnits')
          if (res && res.rst == 0) {
            let temp = {}
            res.data.forEach(d => {
              temp[d.id] = d.name
            })
            this.unitlist = temp
          }
        } catch(err) {

        }
      },
      async doSearch() {
        try {
          this.loading = true
          this.detail = []
          this.detailId = ''
          const data = {
            page_ix: this.currentPage,
            page_size: this.pageSize
          }
          if (this.form.unit_id) {
            data.unit_id = this.form.unit_id
          }
          if (this.form.cdit) {
            data.cdit = this.form.cdit
          }
          const res = await post('help//Session/querySession', data)
          this.loading = false
          if (res && res.rst == 0) {
            this.lessonlist = res.data.data
            this.total = res.data.total
            this.pageStart = (res.data.current_page - 1) * this.pageSize
            this.pageEnd = this.pageStart + this.pageSize
          }
        } catch(err) {
          this.loading = false
        }
      },
      async getDetail(id) {
        this.detailId = id
        try {
          const res = await post('help//Session/getSessionCustomers', {
            id
          })
          if (res && res.rst == 0) {
            this.detail = res.data
          }
        } catch(err) {

        }
      },
      onPageChange(page) {
        this.currentPage = page
        this.doSearch()
      },
      indexMethod(index) {
        return index + this.pageStart + 1;
      }
    },
    name: 'search'
  }
</script>
<style lang="less" scoped>
  
</style>
